import React, { useMemo } from "react";
import { Colors } from "../../../../utils/colors";
import CustomCheckbox from "../../../CustomCheckbox";
import { GenericActionItem } from "../../../DisplayItem/GenericActionItem";
import { CircularProgress } from "@mui/material";

type MassTextsActionItemProps = {
  title: string;
  icon: JSX.Element;
  onPress?: () => void;
  altIconBackgroundColor?: string;
  isCheckSelected?: boolean;
  checkColor?: string;
  alternateRightIcon?: JSX.Element;
  containerStyles?: React.CSSProperties;
  subtext?: string | JSX.Element;
  disabled?: boolean;
  loading?: boolean;
};

export const MassTextsActionItem = (props: MassTextsActionItemProps) => {
  const {
    title,
    icon,
    onPress,
    altIconBackgroundColor,
    isCheckSelected,
    checkColor,
    alternateRightIcon,
    containerStyles,
    subtext,
    disabled,
    loading,
  } = props;
  const styles = {
    actionItemIcon: {
      height: 48,
      width: 48,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      borderRadius: 8,
      cursor: "pointer",
      border: `0.5px solid ${Colors.GRAY2}`,
    },
  };

  const inactive = useMemo(() => disabled || loading, [disabled, loading]);

  return (
    <GenericActionItem
      onPress={onPress}
      containerStyles={containerStyles}
      disabled={inactive}
      textComp={
        <div className="ColumnNormalSelect" style={{ gap: 4 }}>
          <span
            className="TwoLineText"
            style={{ fontWeight: "500", fontSize: 14 }}
          >
            {title}
          </span>
          {subtext && !loading ? (
            <span style={{ fontSize: 12, color: Colors.GRAY1 }}>{subtext}</span>
          ) : null}
        </div>
      }
      leftComp={
        <div
          style={{
            ...styles.actionItemIcon,
            backgroundColor: altIconBackgroundColor ?? Colors.GRAY6,
          }}
        >
          {icon}
        </div>
      }
      rightComp={
        alternateRightIcon ||
        (loading ? (
          <CircularProgress
            style={{ color: Colors.GRAY1, alignSelf: "center" }}
            size={20}
          />
        ) : checkColor ? (
          <CustomCheckbox
            checked={isCheckSelected}
            onChange={onPress}
            sx={{ padding: 0, opacity: onPress ? 1 : 0.7 }}
            altColor={checkColor}
          />
        ) : undefined)
      }
    />
  );
};
